import { useEffect, useRef, useState } from "react";
import "../../styles/website/Rules.css";
import Layout from "../website/component/Layout.jsx";

/* =========================================================
   آیکون‌ها (همه خطی/استروک، بدون ایموجی)
   ========================================================= */

const AlertIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 3L22 20H2L12 3Z" stroke="currentColor" strokeWidth="1.7" strokeLinejoin="round" />
    <path d="M12 9.5V14" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
    <path d="M12 17.2H12.01" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" />
  </svg>
);

const ChevronDownIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
    <path d="M6 9L12 15L18 9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const ArrowLeftIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
    <path d="M15 6L9 12L15 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const CalendarIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
    <rect x="3.5" y="5" width="17" height="16" rx="2.2" stroke="currentColor" strokeWidth="1.7" />
    <path d="M3.5 9.5H20.5" stroke="currentColor" strokeWidth="1.7" />
    <path d="M8 3V6.5M16 3V6.5" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
  </svg>
);

const BuildingIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
    <rect x="5" y="3" width="10" height="18" rx="1.2" stroke="currentColor" strokeWidth="1.7" />
    <path d="M15 21H20V11L15 9" stroke="currentColor" strokeWidth="1.7" strokeLinejoin="round" />
    <path d="M8 7H12M8 11H12M8 15H12" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
  </svg>
);

const DocumentIcon = ({ size = 20 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <path d="M6 2.5H14L19 7.5V21.5H6V2.5Z" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" />
    <path d="M14 2.5V7.5H19" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" />
    <path d="M9 12.5H16M9 16H16" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
  </svg>
);

const StoreIcon = ({ size = 20 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <path d="M4 10V20H20V10" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M3 10L5 4H19L21 10" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M3 10C3 11.7 4.3 13 6 13C7.7 13 9 11.7 9 10C9 11.7 10.3 13 12 13C13.7 13 15 11.7 15 10C15 11.7 16.3 13 18 13C19.7 13 21 11.7 21 10"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
    />
    <path d="M9 20V16H15V20" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" />
  </svg>
);

const UserIcon = ({ size = 20 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <circle cx="12" cy="8" r="3.7" stroke="currentColor" strokeWidth="1.6" />
    <path d="M4.5 20.5C5.5 16.7 8.4 14.5 12 14.5C15.6 14.5 18.5 16.7 19.5 20.5" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
  </svg>
);

const CoinsIcon = ({ size = 20 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <ellipse cx="9" cy="7" rx="6" ry="3" stroke="currentColor" strokeWidth="1.6" />
    <path d="M3 7V13C3 14.7 5.7 16 9 16C12.3 16 15 14.7 15 13V7" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
    <path d="M3 10C3 11.7 5.7 13 9 13C12.3 13 15 11.7 15 10" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
    <ellipse cx="15.5" cy="14" rx="5.5" ry="2.7" stroke="currentColor" strokeWidth="1.6" />
    <path d="M10 14V17.3C10 18.8 12.5 20 15.5 20C18.5 20 21 18.8 21 17.3V14" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
  </svg>
);

const ShieldIcon = ({ size = 20 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <path d="M12 3L20 6V11.5C20 16.4 16.7 20.5 12 22C7.3 20.5 4 16.4 4 11.5V6L12 3Z" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M8.5 12L10.8 14.3L15.5 9.3" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const IdIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
    <rect x="2.5" y="5" width="19" height="14" rx="2.2" stroke="currentColor" strokeWidth="1.6" />
    <circle cx="8.5" cy="12" r="2.2" stroke="currentColor" strokeWidth="1.6" />
    <path d="M5.5 16.3C6.1 14.8 7.2 14 8.5 14C9.8 14 10.9 14.8 11.5 16.3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    <path d="M14.5 9.5H18.5M14.5 12.5H18.5M14.5 15.5H17" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
  </svg>
);

const ScaleIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
    <path d="M12 2.5V21.5M8 21.5H16" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
    <path d="M5 6.5H19" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
    <path d="M12 6.5L5 6.5L2.5 12C2.5 13.8 4 14.8 5.7 14.8C7.4 14.8 8.9 13.8 8.9 12L6.5 6.5" stroke="currentColor" strokeWidth="1.4" strokeLinejoin="round" />
    <path d="M12 6.5L19 6.5L21.5 12C21.5 13.8 20 14.8 18.3 14.8C16.6 14.8 15.1 13.8 15.1 12L17.5 6.5" stroke="currentColor" strokeWidth="1.4" strokeLinejoin="round" />
  </svg>
);

const BanIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
    <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.6" />
    <path d="M6 6L18 18" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
  </svg>
);

const HandshakeIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
    <path d="M2.5 12L6 8.5L9.5 11L13 7.5L16 10" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M2.5 12L6.5 16C7.3 16.8 8.6 16.8 9.4 16L10 15.4" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M16 10L19 13C19.8 13.8 19.8 15 19 15.8C18.2 16.6 17 16.6 16.2 15.8" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M13.5 17.3C14.3 18.1 15.5 18.1 16.3 17.3C17.1 16.5 17.1 15.3 16.3 14.5" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const RefreshIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
    <path d="M3.5 12C3.5 7.3 7.3 3.5 12 3.5C15 3.5 17.6 5 19.1 7.4" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
    <path d="M20.5 12C20.5 16.7 16.7 20.5 12 20.5C9 20.5 6.4 19 4.9 16.6" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
    <path d="M19.1 3.7V7.7H15.1" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M4.9 20.3V16.3H8.9" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const ChartIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
    <path d="M3.5 20.5H20.5" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
    <rect x="5.5" y="13" width="3.2" height="7.5" rx="0.8" stroke="currentColor" strokeWidth="1.5" />
    <rect x="10.4" y="8.5" width="3.2" height="12" rx="0.8" stroke="currentColor" strokeWidth="1.5" />
    <rect x="15.3" y="4" width="3.2" height="16.5" rx="0.8" stroke="currentColor" strokeWidth="1.5" />
  </svg>
);

const CheckCircleIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
    <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.6" />
    <path d="M8 12.3L10.6 15L16 9.3" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const BoxIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
    <path d="M3 8L12 3L21 8V16L12 21L3 16V8Z" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" />
    <path d="M3 8L12 13L21 8" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" />
    <path d="M12 13V21" stroke="currentColor" strokeWidth="1.6" />
  </svg>
);

const TargetIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
    <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.6" />
    <circle cx="12" cy="12" r="5" stroke="currentColor" strokeWidth="1.6" />
    <circle cx="12" cy="12" r="1.3" fill="currentColor" />
  </svg>
);

const ChatIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
    <path
      d="M4 5.5H20V15.5H10.5L6 19V15.5H4V5.5Z"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinejoin="round"
    />
    <path d="M7.5 9.5H16.5M7.5 12.5H13" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
  </svg>
);

const LockIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
    <rect x="4.5" y="10.5" width="15" height="10" rx="2" stroke="currentColor" strokeWidth="1.6" />
    <path d="M7.5 10.5V7.5C7.5 5 9.5 3 12 3C14.5 3 16.5 5 16.5 7.5V10.5" stroke="currentColor" strokeWidth="1.6" />
    <circle cx="12" cy="15" r="1.4" fill="currentColor" />
  </svg>
);

const ClipboardIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
    <rect x="5" y="4.5" width="14" height="17" rx="2" stroke="currentColor" strokeWidth="1.6" />
    <path d="M9 4.5V3.5C9 2.9 9.5 2.5 10 2.5H14C14.5 2.5 15 2.9 15 3.5V4.5" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" />
    <path d="M8.5 11.5L11 14L15.5 9.5" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const CardIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
    <rect x="2.5" y="5.5" width="19" height="13" rx="2.2" stroke="currentColor" strokeWidth="1.6" />
    <path d="M2.5 9.5H21.5" stroke="currentColor" strokeWidth="1.6" />
    <path d="M6 14.5H10" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
  </svg>
);

const WalletIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
    <path d="M3 7C3 5.6 4.1 4.5 5.5 4.5H17C18.7 4.5 20 5.8 20 7.5V17.5C20 19.2 18.7 20.5 17 20.5H6C4.3 20.5 3 19.2 3 17.5V7Z" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" />
    <path d="M15 13.3C15 12.4 15.7 11.7 16.6 11.7H20.5V14.9H16.6C15.7 14.9 15 14.2 15 13.3Z" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" />
  </svg>
);

const BankIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
    <path d="M3 9.5L12 4L21 9.5" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M4 9.5H20V20.5H4V9.5Z" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" />
    <path d="M7.5 12.5V17.5M12 12.5V17.5M16.5 12.5V17.5" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
    <path d="M2.5 20.5H21.5" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
  </svg>
);

const ClockIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
    <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.6" />
    <path d="M12 7V12L15.5 14" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const SearchIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
    <circle cx="10.5" cy="10.5" r="6.5" stroke="currentColor" strokeWidth="1.6" />
    <path d="M15.3 15.3L20 20" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
  </svg>
);

const WarningIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
    <path d="M12 3L22 20H2L12 3Z" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" />
    <path d="M12 9.5V14" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
    <path d="M12 17.2H12.01" stroke="currentColor" strokeWidth="2.1" strokeLinecap="round" />
  </svg>
);

/* =========================================================
   داده‌ها
   ========================================================= */

const SECTIONS = [
  {
    id: "shops",
    title: "قوانین فروشگاه‌ها",
    Icon: StoreIcon,
    items: [
      { Icon: IdIcon, title: "ثبت و احراز هویت", text: "هر فروشگاه موظف است اطلاعات صحیح و کامل هویتی خود را هنگام ثبت‌نام ارائه دهد. ارائه اطلاعات جعلی موجب حذف فوری حساب می‌شود." },
      { Icon: ScaleIcon, title: "رعایت قوانین جمهوری اسلامی", text: "تمامی فروشگاه‌ها ملزم به رعایت کامل قوانین جمهوری اسلامی ایران هستند. هرگونه فعالیت مغایر با قوانین کشور ممنوع است." },
      { Icon: BanIcon, title: "کالاهای ممنوعه", text: "عرضه کالاهای غیرمجاز، قاچاق، تقلبی یا مضر برای سلامت عمومی کاملاً ممنوع است و پیگرد قانونی خواهد داشت." },
      { Icon: HandshakeIcon, title: "رفتار حرفه‌ای", text: "فروشگاه‌ها باید با احترام و حرفه‌ای‌گری با مشتریان رفتار کنند. هرگونه کلاهبرداری یا فریب مشتری موجب تعلیق دائمی می‌شود." },
      { Icon: RefreshIcon, title: "سیاست مرجوعی", text: "هر فروشگاه باید سیاست مرجوعی و تعویض کالای خود را به صورت شفاف در صفحه فروشگاه اعلام کند و به آن پایبند باشد." },
      { Icon: ChartIcon, title: "صداقت در اطلاعات", text: "تمام اطلاعات محصولات شامل قیمت، موجودی، مشخصات فنی و تصاویر باید واقعی و دقیق باشند. اطلاعات گمراه‌کننده ممنوع است." },
    ],
  },
  {
    id: "content",
    title: "مسئولیت محتوا",
    Icon: DocumentIcon,
    notice: "مسئولیت تمامی محتوای منتشرشده در هر فروشگاه به طور کامل بر عهده صاحب آن فروشگاه است.",
    forbidden: [
      "محتوای مغایر با ارزش‌های جمهوری اسلامی ایران",
      "تصاویر، متون یا فایل‌های غیراخلاقی و مستهجن",
      "محتوای توهین‌آمیز به مقدسات، ادیان یا اقوام",
      "تبلیغ کالاها یا خدمات غیرمجاز",
      "نقض حقوق مالکیت معنوی و کپی‌رایت",
      "انتشار اطلاعات شخصی مشتریان بدون رضایت",
    ],
    process: [
      { number: "۱", title: "دریافت گزارش", text: "گزارش محتوای مشکوک توسط کاربران یا تیم نظارت دریافت می‌شود." },
      { number: "۲", title: "بررسی و تذکر", text: "در صورت تأیید تخلف، تذکر کتبی به فروشگاه ارسال می‌شود." },
      { number: "۳", title: "غیرفعال‌سازی", text: "در صورت عدم توجه به تذکر، فروشگاه غیرفعال می‌شود." },
    ],
  },
  {
    id: "sellers",
    title: "قوانین فروشندگان",
    Icon: UserIcon,
    items: [
      { Icon: CheckCircleIcon, title: "رضایت مشتری", text: "فروشنده موظف است تمام سفارشات را با رضایت کامل مشتری انجام دهد. پاسخگویی به شکایات در اسرع وقت الزامی است." },
      { Icon: BoxIcon, title: "مسئولیت ارسال", text: "مسئولیت بسته‌بندی مناسب، ارسال به موقع و صحت کالای ارسالی کاملاً بر عهده فروشنده است." },
      { Icon: TargetIcon, title: "صحت سفارشات", text: "فروشنده مسئول صحت و کیفیت تمام کالاهای ارسالی است. ارسال کالای معیوب یا متفاوت با توضیحات تخلف است." },
      { Icon: ChatIcon, title: "پاسخگویی به مشتریان", text: "فروشنده باید حداکثر ظرف ۲۴ ساعت به پیام‌ها و سوالات مشتریان پاسخ دهد." },
      { Icon: LockIcon, title: "حفظ اطلاعات مشتریان", text: "اطلاعات شخصی مشتریان کاملاً محرمانه است و استفاده از آن برای اهداف غیر از تکمیل سفارش ممنوع است." },
      { Icon: ClipboardIcon, title: "مجوزهای قانونی", text: "فروشنده باید تمام مجوزهای لازم برای فروش کالاهای خود را داشته باشد و در صورت درخواست ارائه دهد." },
    ],
    notice: "مسئولیت تمام کالاها، ارسال‌ها، پاسخگویی به مشتریان و کیفیت محصولات به طور کامل بر عهده صاحب فروشگاه است. پلتفرم دکانا صرفاً بستر فروش را فراهم می‌کند.",
  },
  {
    id: "finance",
    title: "قوانین مالی",
    Icon: CoinsIcon,
    items: [
      { Icon: CardIcon, title: "پرداخت هزینه اشتراک", text: "فعال‌سازی فروشگاه منوط به پرداخت کامل هزینه اشتراک است. فروشگاه پس از تأیید پرداخت فعال می‌شود." },
      { Icon: WalletIcon, title: "شارژ کیف پول", text: "در صورتی که کاربر برای دیگران از طریق حساب کاربری خود سایتی را اضافه کند، درصد پورسانت به کیف پول او شارژ می‌شود." },
      { Icon: BankIcon, title: "حداقل برداشت", text: "حداقل مبلغ قابل برداشت در هر درخواست ۵,۰۰۰,۰۰۰ تومان است. برداشت‌های بیشتر از ۱۰۰,۰۰۰,۰۰۰ تومان نیاز به تأیید مدیریت دارد." },
      { Icon: ClockIcon, title: "زمان تسویه", text: "تسویه حساب فروشندگان پس از تأیید تحویل سفارش توسط مشتری، حداکثر ظرف ۷۲ ساعت کاری انجام می‌شود." },
      { Icon: SearchIcon, title: "شفافیت مالی", text: "تمام تراکنش‌های مالی در پنل فروشگاه قابل مشاهده است. در صورت مغایرت، ظرف ۴۸ ساعت اعلام کنید." },
      { Icon: WarningIcon, title: "تخلفات مالی", text: "هرگونه تلاش برای دور زدن سیستم پرداخت یا تراکنش‌های مشکوک منجر به مسدودسازی فوری حساب می‌شود." },
    ],
    notice: "هرگونه فعالیت مالی خارج از چارچوب پلتفرم دکانا منجر به مسدودسازی دائمی حساب و پیگرد قانونی خواهد شد.",
  },
  {
    id: "disclaimer",
    title: "سلب مسئولیت",
    Icon: ShieldIcon,
    lead: "پلتفرم دکانا و گروه مهندسی باور سازان صرفاً یک بستر فناورانه برای اتصال فروشندگان و خریداران فراهم می‌کنند و هیچ‌گونه مسئولیتی در قبال موارد زیر ندارند:",
    list: [
      "کیفیت، صحت یا قانونی بودن کالاها و خدمات ارائه‌شده توسط فروشگاه‌ها",
      "اختلافات بین فروشنده و خریدار",
      "تأخیر یا عدم ارسال کالا توسط فروشنده",
      "محتوای منتشرشده در صفحات فروشگاه‌ها",
      "خسارات مستقیم یا غیرمستقیم ناشی از استفاده از پلتفرم",
      "اطلاعات نادرست ارائه‌شده توسط فروشندگان",
      "هرگونه خسارت ناشی از قطعی یا اختلال در سرویس",
    ],
  },
];

/* =========================================================
   کامپوننت‌ها
   ========================================================= */

function Notice({ children }) {
  return (
    <div className="legal-notice">
      <span className="legal-notice-icon">
        <AlertIcon />
      </span>
      <p>{children}</p>
    </div>
  );
}

function RuleItem({ Icon, title, text }) {
  return (
    <div className="legal-rule">
      <span className="legal-rule-icon">
        <Icon />
      </span>
      <div>
        <h4>{title}</h4>
        <p>{text}</p>
      </div>
    </div>
  );
}

function ProcessRow({ step, isLast }) {
  return (
    <div className="legal-process-row">
      <div className="legal-process-node">{step.number}</div>
      <div className="legal-process-body">
        <h4>{step.title}</h4>
        <p>{step.text}</p>
      </div>
      {!isLast && <div className="legal-process-line" />}
    </div>
  );
}

function SectionAccordion({ section, index, isOpen, onToggle, setRef }) {
  const { Icon } = section;
  return (
    <section id={section.id} ref={setRef} className={`legal-section tile ${isOpen ? "is-open" : ""}`}>
      <button className="legal-section-head" onClick={onToggle} aria-expanded={isOpen}>
        <span className="legal-section-num">{index + 1}</span>
        <span className="legal-section-icon">
          <Icon size={19} />
        </span>
        <span className="legal-section-title">{section.title}</span>
        <span className="legal-section-chevron">
          <ChevronDownIcon />
        </span>
      </button>

      {isOpen && (
        <div className="legal-section-body">
          {section.items && (
            <div className="legal-rules-grid">
              {section.items.map((item) => (
                <RuleItem key={item.title} {...item} />
              ))}
            </div>
          )}
          {section.items && section.notice && <Notice>{section.notice}</Notice>}

          {section.forbidden && (
            <>
              <Notice>{section.notice}</Notice>
              <h4 className="legal-subtitle">محتوای ممنوعه</h4>
              <ul className="legal-forbidden-list">
                {section.forbidden.map((f) => (
                  <li key={f}>
                    <span className="legal-dot" />
                    {f}
                  </li>
                ))}
              </ul>
              <h4 className="legal-subtitle">فرآیند رسیدگی به گزارش‌ها</h4>
              <div className="legal-process">
                {section.process.map((step, i) => (
                  <ProcessRow key={step.number} step={step} isLast={i === section.process.length - 1} />
                ))}
              </div>
            </>
          )}

          {section.lead && (
            <>
              <p className="legal-lead">{section.lead}</p>
              <ul className="legal-plain-list">
                {section.list.map((l) => (
                  <li key={l}>
                    <span className="legal-dot" />
                    {l}
                  </li>
                ))}
              </ul>
            </>
          )}
        </div>
      )}
    </section>
  );
}

export default function Rules() {
  const [openIds, setOpenIds] = useState(() => new Set([SECTIONS[0].id]));
  const [activeId, setActiveId] = useState(SECTIONS[0].id);
  const [tocMode, setTocMode] = useState("static"); // static | fixed | bottom
  const [tocRect, setTocRect] = useState({ left: 0, width: 0 });

  const sectionRefs = useRef({});
  const tocRefs = useRef({});
  const isClickScrolling = useRef(false);
  const tocSlotRef = useRef(null);
  const tocPanelRef = useRef(null);
  const contentColRef = useRef(null);

  const PIN_TOP = 90;

  const toggle = (id) => {
    setOpenIds((prev) => {
      const next = new Set(prev);
      next.has(id) ? next.delete(id) : next.add(id);
      return next;
    });
  };

  const scrollTo = (id) => {
    isClickScrolling.current = true;
    setActiveId(id);
    setOpenIds((prev) => new Set(prev).add(id));
    requestAnimationFrame(() => {
      sectionRefs.current[id]?.scrollIntoView({ behavior: "smooth", block: "start" });
    });
    window.clearTimeout(scrollTo._t);
    scrollTo._t = window.setTimeout(() => {
      isClickScrolling.current = false;
    }, 700);
  };

  // اسکرول‌اسپای: هر بخشی که وسط صفحه‌ست به عنوان فعال علامت می‌خوره
  // (فقط توی دسکتاپ؛ روی موبایل با اسکرول صفحه، تب فعال عوض نمی‌شه و فقط با تپ زدن تغییر می‌کنه)
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (isClickScrolling.current) return;
        if (window.innerWidth < 981) return;
        const visible = entries
          .filter((e) => e.isIntersecting)
          .sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];
        if (visible?.target?.id) {
          setActiveId(visible.target.id);
        }
      },
      { rootMargin: "-15% 0px -60% 0px", threshold: [0, 0.25, 0.5, 1] }
    );

    Object.values(sectionRefs.current).forEach((el) => el && observer.observe(el));
    return () => observer.disconnect();
  }, []);

  // فهرست مطالب هم به‌صورت خودکار همراه با آیتم فعال اسکرول می‌شه (فقط دسکتاپ)
  useEffect(() => {
    if (window.innerWidth < 981) return;
    tocRefs.current[activeId]?.scrollIntoView({ block: "nearest", inline: "nearest", behavior: "smooth" });
  }, [activeId]);

  // فهرست مطالب: کاملاً ثابت روی صفحه، بدون جابه‌جایی با اسکرول
  // (به‌جای position:sticky که به رفتار والدها وابسته‌ست، این‌جا با اندازه‌گیری
  // مستقیم موقعیت و ارتفاع، خودمون تصمیم می‌گیریم کِی fixed بشه و کجا متوقف بشه)
  useEffect(() => {
    const slot = tocSlotRef.current;
    const panel = tocPanelRef.current;
    if (!slot || !panel) return;

    let raf = null;

    const measure = () => {
      raf = null;

      if (window.innerWidth < 981) {
        setTocMode("static");
        return;
      }

      const slotRect = slot.getBoundingClientRect();
      const slotTopDoc = slotRect.top + window.scrollY;
      const panelHeight = panel.offsetHeight;
      const scrollY = window.scrollY;

      const contentEl = contentColRef.current;
      const contentBottomDoc = contentEl
        ? contentEl.getBoundingClientRect().bottom + window.scrollY
        : Infinity;

      if (scrollY + PIN_TOP < slotTopDoc) {
        setTocMode("static");
      } else if (scrollY + PIN_TOP + panelHeight > contentBottomDoc) {
        setTocMode("bottom");
      } else {
        setTocRect({ left: slotRect.left, width: slotRect.width });
        setTocMode("fixed");
      }
    };

    const onScrollOrResize = () => {
      if (raf) return;
      raf = requestAnimationFrame(measure);
    };

    measure();
    window.addEventListener("scroll", onScrollOrResize, { passive: true });
    window.addEventListener("resize", onScrollOrResize);
    return () => {
      if (raf) cancelAnimationFrame(raf);
      window.removeEventListener("scroll", onScrollOrResize);
      window.removeEventListener("resize", onScrollOrResize);
    };
  }, []);

  return (
    <Layout>
      <section className="legal-hero">
        <div className="wrap">
          <h1>قوانین و مقررات دکانا</h1>
          <p className="legal-sub">
            برای استفاده از پلتفرم دکانا، لطفاً قوانین و مقررات زیر را به دقت مطالعه فرمایید. ثبت‌نام و
            استفاده از خدمات به منزله‌ی پذیرش کامل این قوانین است.
          </p>
          <div className="trust-chips">
            <span className="chip tile">
              <CalendarIcon /> آخرین بروزرسانی: خرداد ۱۴۰۵
            </span>
            <span className="chip tile">
              <BuildingIcon /> گروه مهندسی باور سازان
            </span>
          </div>
        </div>
      </section>

      <section className="legal-body">
        <div className="wrap legal-layout">
          <div className="legal-toc-slot" ref={tocSlotRef}>
            <aside
              ref={tocPanelRef}
              className={`legal-toc tile toc-${tocMode}`}
              style={tocMode === "fixed" ? { top: PIN_TOP, left: tocRect.left, width: tocRect.width } : undefined}
            >
              <span className="legal-toc-label">فهرست مطالب</span>
              <nav>
                {SECTIONS.map((s) => (
                  <button
                    key={s.id}
                    ref={(el) => (tocRefs.current[s.id] = el)}
                    className={`legal-toc-link ${activeId === s.id ? "is-active" : ""}`}
                    onClick={() => scrollTo(s.id)}
                  >
                    <ArrowLeftIcon />
                    {s.title}
                  </button>
                ))}
              </nav>
            </aside>
          </div>

          <div className="legal-content" ref={contentColRef}>
            <Notice>عدم رعایت هر یک از این قوانین می‌تواند منجر به تعلیق یا حذف حساب شود.</Notice>

            {SECTIONS.map((section, i) => (
              <SectionAccordion
                key={section.id}
                section={section}
                index={i}
                isOpen={openIds.has(section.id)}
                onToggle={() => toggle(section.id)}
                setRef={(el) => (sectionRefs.current[section.id] = el)}
              />
            ))}

            <div className="legal-footnote tile">
              <p>
                با ثبت‌نام و استفاده از پلتفرم دکانا، کاربر تأیید می‌کند که این قوانین را مطالعه کرده و با
                تمام مفاد آن موافقت می‌نماید. این قوانین ممکن است بدون اطلاع قبلی تغییر کنند.
              </p>
              <span className="legal-copyright">
                © ۱۴۰۵ دکانا — گروه مهندسی باور سازان. تمامی حقوق محفوظ است. · info@dokana.ir ·
                www.dokana.ir
              </span>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
}
